<ng-container *transloco="let t; read: 'documents.topic-editor'">
  @if (!deletePressed) {
    <h3>{{ t('topic') }}</h3>
    @if (topic.type === 'manual') {
      <mat-form-field class="full-width">
        <mat-label>{{ t('title') }}</mat-label>
        <input
          matInput
          autocomplete="off"
          name="topicname"
          [ngModel]="topic.title"
          [disabled]="isTitleCompletionInProgress"
          [matAutocomplete]="titleAutocomplete"
          [formControl]="titleFormControl"
        />
        <mat-autocomplete
          #titleAutocomplete="matAutocomplete"
          (optionSelected)="autocompleteOptionSelected($event)"
        >
          @for (r of autocompleteResult | async; track r) {
            <mat-option [value]="r.title" [disabled]="!!r.disabled">
              {{ r.title }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <div class="label-value">{{ t('label', { label: topic.title }) }}</div>
    }
    @if (topic.type !== 'manual' && topic.type !== 'query') {
      <div class="label-value">
        {{ t('score', { score: topic.strengthScore }) }}
      </div>
    }
    @if (topic.type === 'concept') {
      <h3>{{ t('training-keywords') }}</h3>
      <div class="full-width topic-editor__text-area-container">
        <xi-text-area
          [value]="topicConfig?.samples?.join(', ')"
          name="training-keywords"
          [height]="100"
          [readOnly]="true"
        ></xi-text-area>
      </div>
    }
    @if (topic.type === 'query') {
      <h3>{{ t('query') }}</h3>
      <div class="full-width topic-editor__text-area-container">
        <xi-text-area
          [value]="topicConfig?.query"
          name="query"
          [height]="100"
          [readOnly]="true"
        ></xi-text-area>
      </div>
    }
    @if (topicTypeHasHits(topic)) {
      <h3>{{ t('hits') }}</h3>
      <table mat-table [dataSource]="getTopicHits(topic)" class="full-width">
        <tr mat-header-row *matHeaderRowDef="hitsTableConfig[topic.type].columns"></tr>
        <tr mat-row *matRowDef="let row; columns: hitsTableConfig[topic.type].columns"></tr>
        <ng-container matColumnDef="phrase">
          <th mat-header-cell *matHeaderCellDef disabled>{{ t('content') }}</th>
          <td mat-cell *matCellDef="let item">
            {{ item.phrase.title }}
          </td>
        </ng-container>
        <ng-container matColumnDef="mention">
          <th mat-header-cell *matHeaderCellDef disabled>{{ t('content') }}</th>
          <td mat-cell *matCellDef="let item">
            {{ item.label }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sentimentScore">
          <th mat-header-cell *matHeaderCellDef disabled>{{ t('score-label') }}</th>
          <td mat-cell *matCellDef="let item">
            {{ item.sentimentScore | number: '1.2-2' }}
          </td>
        </ng-container>
      </table>
    }
    <div class="configuration-buttons-container">
      <div [matTooltip]="editConfigButtonTooltip">
        @if (topic.type === 'auto') {
          <div>
            <xi-default-button
              [text]="t('edit-blacklist')"
              fill="text"
              [hasAnimation]="false"
              [disabled]="!canEditConfig"
              (onClick)="editBlacklist()"
            ></xi-default-button>
          </div>
        }
        @if (topic.type === 'concept' || topic.type === 'auto' || topic.type === 'query') {
          <div>
            <xi-default-button
              [text]="t('edit-configuration')"
              fill="text"
              [hasAnimation]="false"
              [disabled]="!canEditConfig"
              (onClick)="editConfig()"
            ></xi-default-button>
          </div>
        }
      </div>
    </div>
    @if (topic.type === 'model') {
      <div class="topic-hit-slider">
        <xi-toggle-switch
          [(ngModel)]="topicShouldHit"
          [label]="t('should-hit')"
          [leftText]="t('no')"
          [rightText]="t('yes')"
        ></xi-toggle-switch>
      </div>
    }
    @if (topic.type !== 'model') {
      <app-sentiment-control
        [projectId]="options().projectId"
        [sentimentScale]="options().sentimentScale"
        [sentimentScore]="topic.sentimentScore"
        [sentimentValue]="sentimentValue"
        sentimentRangeType="feature"
        (manualSentimentChange)="onSentimentChanged($event)"
      ></app-sentiment-control>
    }
  } @else {
    <h3>{{ t('delete-topic-title') }}</h3>
    <p>{{ t('delete-topic-content', { title: topic.title, type: topic.type }) }}</p>
    <ng-container *ngTemplateOutlet="comments"></ng-container>
  }

  <div class="topic-editor__buttons-container">
    <xi-default-button
      [text]="t('cancel')"
      fill="text"
      [hasAnimation]="false"
      (onClick)="cancelTopic()"
    ></xi-default-button>

    @if (topicToEdit().id && topic.type !== 'model' && !hasChanges()) {
      <div>
        <xi-default-button
          [text]="t('delete')"
          fill="text"
          [hasAnimation]="false"
          color="warning"
          [disabled]="isLoading()"
          (onClick)="deleteTopic()"
        >
        </xi-default-button>
      </div>
    }
    @if (!deletePressed) {
      <div>
        <xi-default-button
          [text]="t('save')"
          color="CX"
          fill="text"
          [hasAnimation]="false"
          [disabled]="isLoading() || !formValid() || !hasChanges()"
          (onClick)="saveTopic()"
        ></xi-default-button>
      </div>
    }
  </div>

  @if (hasChanges()) {
    <ng-container *ngTemplateOutlet="comments"></ng-container>
  }

  <ng-template #comments>
    <label for="topic-editor-comment-input" class="kxi-text-large">{{ t('comments') }}</label>

    <div class="full-width topic-editor__text-area-container">
      <xi-text-area
        id="topic-editor-comment-input"
        [placeholder]="t('leave-comment')"
        ngDefaultControl
        [(ngModel)]="comment"
        name="comment"
        [height]="100"
      ></xi-text-area>
    </div>
  </ng-template>
</ng-container>
